<template>
  <div>
    <blockquote class="otro-blockquote is-size-5">
      {{ text }}
      <span>{{ author }}</span>
    </blockquote>
  </div>
</template>

<script>
export default {
  props: ["text", "author"]
};
</script>

<style lang="scss" scoped>
.otro-blockquote {
  margin: 0px auto;
  font-style: italic;
  color: #1f1f1f;
  padding: 1.2em 30px 1.2em 75px;
  border-left: 8px solid #9fa8f4;
  line-height: 1.6;
  position: relative;
  background: #d2daef;
}

.otro-blockquote::before {
  content: "\201C";
  color: #9fa8f4;
  font-size: 4em;
  position: absolute;
  left: 10px;
  top: -10px;
}

.otro-blockquote::after {
  content: "";
}

.otro-blockquote span {
  display: block;
  color: #333333;
  font-style: normal;
  font-weight: bold;
  margin-top: 1em;
}
</style>
